import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MediaItemWithComments} from "../lightbox/lightbox.component";

@Component({
    selector: 'app-full-screen-image',
    templateUrl: './full-screen-image.component.html',
    styleUrl: './full-screen-image.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FullScreenImageComponent {
    currentMedia: MediaItemWithComments | undefined;

    constructor(@Inject(MAT_DIALOG_DATA) private data: MediaItemWithComments,
                public dialog: MatDialog,
                protected dialogRef: MatDialogRef<FullScreenImageComponent>) {

        if (data) {
            this.currentMedia = data;
        }

    }

}
